import { render } from "./LinkSupplierInvoiceToFixture.vue?vue&type=template&id=2184003c"
import script from "./LinkSupplierInvoiceToFixture.vue?vue&type=script&lang=js"
export * from "./LinkSupplierInvoiceToFixture.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__